// This generates the initial controls/scaffolding for the custom integrated google map controls. Should only be called once.
export const buildCustomMapControls = async (vueInstance) => {
    let self = vueInstance;

    // Build show map controls control toggle ////////////
    let showFiltersControl = document.createElement('div');
    showFiltersControl.setAttribute('id', 'show-filters-toggle');
    showFiltersControl.index = 1;
    showFiltersControl.innerHTML = `
        <span id="show-filters-toggle-icon" class="icon mdi mdi-menu"> </span>
    `;
    showFiltersControl.addEventListener('click', function(e) {
        self.showViewControls = !self.showViewControls;
        document.getElementsByClassName('geomap-view-select')[0].style.display = self.showViewControls ? 'initial' : 'none';
        document.getElementById('show-geomap-view-management-toggle').hidden = !self.showViewControls;
        document.getElementById('save-geomap-view-button').hidden = !self.showViewControls;

        document.getElementById('edit-geomap-settings-button').hidden = !self.showViewControls;
        //document.getElementById('map-filtered-out-info-control').hidden = !self.showViewControls;
        document.getElementById('cycle-map-views-control').hidden = !self.showViewControls;
    });
    self.googleMapsObj.controls[google.maps.ControlPosition.TOP_LEFT].push(showFiltersControl);




    // Build show GeoMap view management toggle ////////////
    let showGeoMapViewManagementControl = document.createElement('div');
    showGeoMapViewManagementControl.setAttribute('id', 'show-geomap-view-management-toggle');
    showGeoMapViewManagementControl.index = 2;
    showGeoMapViewManagementControl.innerHTML = `
        <span id="show-geomap-view-management-toggle-icon" class="icon mdi mdi-monitor-multiple"> </span>
    `;
    showGeoMapViewManagementControl.addEventListener('click', function(e) {
        self.showGeoMapViewManagement = true;
    });
    self.googleMapsObj.controls[google.maps.ControlPosition.TOP_LEFT].push(showGeoMapViewManagementControl);

    // Build save GeoMap View Button ////////////
    let saveGeoMapButton = document.createElement('div');
    saveGeoMapButton.setAttribute('id', 'save-geomap-view-button');
    saveGeoMapButton.index = 2;
    saveGeoMapButton.innerHTML = `
        <span id="save-geomap-view-button-icon" class="icon mdi mdi-content-save"> </span>
    `;
    saveGeoMapButton.addEventListener('click', function(e) {
        self.showViewsFavsDetails = true;
    });
    self.googleMapsObj.controls[google.maps.ControlPosition.TOP_LEFT].push(saveGeoMapButton);




    // Build Edit GeoMap Settings Button ////////////
    let editGeoMapButton = document.createElement('div');
    editGeoMapButton.setAttribute('id', 'edit-geomap-settings-button');
    editGeoMapButton.index = 1;
    editGeoMapButton.innerHTML = `
        <span id="edit-geomap-settings-button-icon" class="icon mdi mdi-cog"> </span>
    `;
    editGeoMapButton.addEventListener('click', function(e) {
        self.showGeoMapSettings = true;
    });
    self.googleMapsObj.controls[google.maps.ControlPosition.LEFT_TOP].push(editGeoMapButton);

    // // Build map view cycle controls scaffolding ////////////
    let viewsControlDiv = document.createElement('div');
    createCycleMapViewsControl(self, viewsControlDiv);
    viewsControlDiv.index = 1;
    self.googleMapsObj.controls[google.maps.ControlPosition.LEFT_TOP].push(viewsControlDiv);


    // Build filtered out info container ////////////
    // let filteredOutInfoControl = document.createElement('div');
    // filteredOutInfoControl.setAttribute('id', 'map-filtered-out-info-control');
    // filteredOutInfoControl.innerHTML = `
    //     <div class="map-filtered-out-info-container">
    //         <span id="map-filtered-out-sites-value" class="map-filtered-out-number">0</span>
    //         <span id="map-filtered-out-sites-icon" class="map-filtered-out-icon icon mdi mdi-radioactive"></span>
    //     </div>
    //     <div class="map-filtered-out-info-container">
    //         <span id="map-filtered-out-alarms-value" class="map-filtered-out-number">0</span>
    //         <span id="map-filtered-out-sites-icon" class="map-filtered-out-icon icon mdi mdi-bell"></span>
    //     </div>
    // `;
    // filteredOutInfoControl.index = 1;
    // self.googleMapsObj.controls[google.maps.ControlPosition.LEFT_TOP].push(filteredOutInfoControl);



    // Build directions container ////////////
    let googleMapsDirectionsContainer = document.createElement('div');
    googleMapsDirectionsContainer.setAttribute('id', 'google-maps-directions-container');
    let googleMapsDirectionsClose = document.createElement('div');
    googleMapsDirectionsClose.setAttribute('id', 'google-maps-directions-close');
    googleMapsDirectionsClose.innerHTML = `<span class="mdi mdi-close-circle" />`

    googleMapsDirectionsClose.addEventListener('click', function() {
        self.directionsRenderer.setMap(null);
        self.directionsRenderer.setPanel(null);
        document.getElementById('google-maps-directions-container').style.display = 'none';
    });
    googleMapsDirectionsContainer.appendChild(googleMapsDirectionsClose);
    googleMapsDirectionsContainer.index = 1;
    self.googleMapsObj.controls[google.maps.ControlPosition.RIGHT_TOP].push(googleMapsDirectionsContainer);

    // Build active view name text; ////////////
    let activeViewNameTextContainer = document.createElement('div');
    activeViewNameTextContainer.setAttribute('id', 'active-view-name-text-container');
    activeViewNameTextContainer.index = 1;
    self.googleMapsObj.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(activeViewNameTextContainer);


    // Build unmatched alarms control ////////////
    let unMatchedAlarmsControl = document.createElement('div');
    unMatchedAlarmsControl.setAttribute('id', 'unmatched-alarms-list-control');
    unMatchedAlarmsControl.index = 1;
    let unMatchedAlarmsControlTitle = document.createElement('div');
    unMatchedAlarmsControlTitle.setAttribute('id', 'unmatched-alarms-list-control-title');
    unMatchedAlarmsControlTitle.addEventListener('click', function(e) {
        let element = document.getElementById(`unmatched-alarms-list-control`);
        if(element.classList.contains('expanded')) {
            element.classList.remove('expanded');
        }
        else {
            element.classList.add('expanded');
        }
    });
    let unMatchedAlarmsControlList = document.createElement('div');
    unMatchedAlarmsControlList.setAttribute('id', 'unmatched-alarms-list-control-list');
    unMatchedAlarmsControl.appendChild(unMatchedAlarmsControlTitle);
    unMatchedAlarmsControl.appendChild(unMatchedAlarmsControlList);
    self.googleMapsObj.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(unMatchedAlarmsControl);


    // Build search control toggle ////////////
    let searchControl = document.createElement('div');
    searchControl.setAttribute('id', 'search-control-toggle');
    searchControl.index = 1;
    searchControl.innerHTML = `
        <span id="search-control-icon" class="icon mdi mdi-magnify"> </span>
    `;
    searchControl.addEventListener('click', function(e) {
        self.showSearch = !self.showSearch;
    });
    self.googleMapsObj.controls[google.maps.ControlPosition.TOP_RIGHT].push(searchControl);

    // Build marker control toggle ////////////
    let markerControl = document.createElement('div');
    markerControl.setAttribute('id', 'marker-control-toggle');
    markerControl.index = 1;
    markerControl.innerHTML = `
        <span id="marker-control-icon" class="icon mdi mdi-map-marker"> </span>
    `;
    markerControl.addEventListener('click', function(e) {
        self.placesSearchShow = !self.placesSearchShow;
    });
    self.googleMapsObj.controls[google.maps.ControlPosition.RIGHT_TOP].push(markerControl);

    // Build custom fullscreen control ////////////
    let fullscreenControl = document.createElement('div');
    fullscreenControl.setAttribute('id', 'fullscreen-control');
    fullscreenControl.index = 2;
    fullscreenControl.innerHTML = `
        <span id="fullscreen-control-icon" class="icon mdi mdi-fullscreen"> </span>
    `;
    fullscreenControl.addEventListener('click', function(e) {
        self.toggleFullscreen();
    });
    self.googleMapsObj.controls[google.maps.ControlPosition.RIGHT_TOP].push(fullscreenControl);


    
    // this needs to be in a delay("0" makes it run as soon as the DOM as updated) because the DOM needs to update before we can attach stuff to it.
    //console.log('BEFORE');
    await TELSA.waitUntil((function() {return (document.getElementById(`map-views-cycle-switch`) && document.getElementById(`unmatched-alarms-list-control-title`))}), 3000);
    //console.log('AFTER');
    
    // Attach click event listener to map view cycle enabled control ////////////
    document.getElementById(`map-views-cycle-switch`).checked = self.autoCycleSettings.autoCycleEnabled;
    document.getElementById('map-views-cycle-switch').addEventListener('click', function(e) {
        self.autoCycleSettings.autoCycleEnabled = !self.autoCycleSettings.autoCycleEnabled;
        if(!self.autoCycleSettings.autoCycleEnabled) {
            self.hideActiveMapViewNameText();
        }
        self.setupAutoCycleFunc();
    });

    // Attach click event listener to map view cycle time ////////////
    document.getElementById(`map-views-cycle-time`).value = self.autoCycleSettings.autoCycleTime;
    document.getElementById(`map-views-cycle-time`).addEventListener('input', function(e) {
        self.autoCycleSettings.autoCycleTime = self.value;
        self.setupAutoCycleFunc();
    });
    buildMapViewsList(self);
};



export const hideActiveMapViewNameText = () => {
    document.getElementById('active-view-name-text-container').style.display = "none";
};



export const buildMapViewsList = (vueInstance) => {
    let self = vueInstance;
    
    document.getElementById(`cycle-map-views-list-container`).innerHTML = ``;
    for(let geoMapView of self.geoMapViews) {
        let myView = (geoMapView.user_id == self.$store.state.user.user_id);
        let mapViewAutoCycleEnabled = self.autoCycleSettings.mapViews.some(v => v.user_id == geoMapView.user_id && v.view_name == geoMapView.view_name);
        let mapViewItem = document.createElement('div');
        mapViewItem.setAttribute('class', 'map-view-container');
        
        let mapViewTextContainer = document.createElement('div');
        mapViewTextContainer.setAttribute('class', 'text-container');
        let mapViewName;
        mapViewName = document.createElement('span');
        mapViewName.setAttribute('class', 'map-view-name');
        mapViewName.innerHTML = `${geoMapView.view_name}`;

        // Created By Text
        let mapViewCreatedBy = document.createElement('span');
        mapViewCreatedBy.setAttribute('class', 'map-view-created-by');
        mapViewCreatedBy.innerHTML = `Created By: ${self.$store.state.batchConfig.users.find(u => {return u.user_id == geoMapView.user_id}).user_username}`;

        mapViewTextContainer.appendChild(mapViewName);
        mapViewTextContainer.appendChild(mapViewCreatedBy);
        
        let mapViewButtonContainer = document.createElement('div');
        mapViewButtonContainer.setAttribute('class', 'button-container');

        // Cycle Switch
        let mapViewCycleSwitchContainer = document.createElement('label');
        mapViewCycleSwitchContainer.setAttribute('class', 'switch small');
        let mapViewCycleSwitchContainerInput = document.createElement('input');
        mapViewCycleSwitchContainerInput.setAttribute('type', 'checkbox');
        mapViewCycleSwitchContainerInput.checked = mapViewAutoCycleEnabled;
        let mapViewCycleSwitchContainerSpan = document.createElement('span');
        mapViewCycleSwitchContainerSpan.setAttribute('class', 'slider small round');
        mapViewCycleSwitchContainerInput.addEventListener('click', function(e) {
            if(self.autoCycleSettings.mapViews.some(v => v.user_id == geoMapView.user_id && v.view_name == geoMapView.view_name)) {
                self.autoCycleSettings.mapViews.splice(self.autoCycleSettings.mapViews.findIndex(v => v.user_id == geoMapView.user_id && v.view_name == geoMapView.view_name), 1);
            }
            else {
                self.autoCycleSettings.mapViews.push({user_id: geoMapView.user_id, view_name: geoMapView.view_name});
            }
            hideActiveMapViewNameText();
            //self.$store.commit('setIsDirty', true);
        });

        mapViewCycleSwitchContainer.appendChild(mapViewCycleSwitchContainerInput);
        mapViewCycleSwitchContainer.appendChild(mapViewCycleSwitchContainerSpan);
        mapViewButtonContainer.appendChild(mapViewCycleSwitchContainer);
        mapViewItem.appendChild(mapViewTextContainer);
        mapViewItem.appendChild(mapViewButtonContainer);
        document.getElementById(`cycle-map-views-list-container`).appendChild(mapViewItem);
        self.currentCycleMapViewIndex = 0;
    }
};


export const createCycleMapViewsControl = (vueInstance, controlDiv) => {
    let self = vueInstance;

    let controlUI = document.createElement('div');
    controlUI.setAttribute('id', 'cycle-map-views-control');
    controlDiv.appendChild(controlUI);

    let controlText = document.createElement('div');
    controlText.setAttribute('id', 'cycle-map-views-control-title');
    controlText.title = 'Toggle showing cycle map views';
    controlText.innerHTML = 'Cycle Map Views';

    controlText.addEventListener('click', function(e) {
        let element = document.getElementById(`cycle-map-views-control`);
        if(element.classList.contains('expanded')) {
            element.classList.remove('expanded');
        }
        else {
            element.classList.add('expanded');
        }
    });
    controlUI.appendChild(controlText);

    // cycle settings
    let cycleSettingsContainer = document.createElement('div');
    cycleSettingsContainer.setAttribute('class', 'cycle-map-views-cycle-settings-container');

    // Auto cycle control
    let cycleSwitchSettingContainer = document.createElement('div');
    cycleSwitchSettingContainer.innerHTML = `
        <div class="map-views-cycle-control">    
            <label for="map-views-cycle-control" class="v-label theme--dark" style="left: 0px; right: auto; position: relative; color: #191919">Enabled</label>
            <label class="switch">
                <input id="map-views-cycle-switch" type="checkbox">
                <span class="slider round"></span>
            </label>
        </div>
    `;
    cycleSettingsContainer.appendChild(cycleSwitchSettingContainer);

    // Auto cycle time control
    let cycleTimeSettingContainer = document.createElement('div');
    cycleTimeSettingContainer.innerHTML = `
        <div class="map-views-cycle-control">
            <label for="map-views-cycle-time" class="v-label theme--dark" style="left: 0px; right: auto; position: relative; color: #191919">Interval Time(sec)</label>
            <input id="map-views-cycle-time" type="number" min="1" step="1">
        </div>
    `;
    cycleSettingsContainer.appendChild(cycleTimeSettingContainer);

    // Auto cycle save button
    let saveContainer = document.createElement('div');
    saveContainer.setAttribute('class', 'map-views-new-save-button');
    saveContainer.innerHTML = `
        <button id="map-views-save-button">Save</button>
    `;
    saveContainer.addEventListener('click', function(e) {
        self.saveAutoCycleSettings();
    });

    // Map views
    let mapViewsListContainer = document.createElement('div');
    mapViewsListContainer.setAttribute('id', 'cycle-map-views-list-container');
    controlUI.appendChild(cycleSettingsContainer);
    controlUI.appendChild(mapViewsListContainer);
    controlUI.appendChild(saveContainer);
};


export const buildUnMatchedAlarmsListControl = (vueInstance) => {
    let self = vueInstance;

    let geoColors = self.$store.state.batchConfig.webapp_settings.alarms.alarmColors.geographical;
    self.unMatchedAlarms.criticalCount = 0;
    self.unMatchedAlarms.majorCount = 0;
    self.unMatchedAlarms.minorCount = 0;
    self.unMatchedAlarms.observationalCount = 0;
    self.unMatchedAlarms.defaultCount = 0;
    for(let alarm of self.unMatchedAlarms.list) {
        let alarmSeverity = alarm.alarm_severity.toLowerCase();
        switch(alarmSeverity) {
            case 'critical':
                self.unMatchedAlarms.criticalCount++;
                break;
            case 'major':
                self.unMatchedAlarms.majorCount++;
                break;
            case 'minor':
                self.unMatchedAlarms.minorCount++;
                break;
            case 'observational':
                self.unMatchedAlarms.observationalCount++;
                break;
            default:
                self.unMatchedAlarms.defaultCount++;
        }
    }
    document.getElementById('unmatched-alarms-list-control-title').innerHTML = `<span class="icon mdi mdi-bell-ring" />`;
    document.getElementById('unmatched-alarms-list-control-list').innerHTML = `
        <div class="total">
            <span>Un-Matched Alarms: <b>${self.unMatchedAlarms.list.length}</b></span>
        </div>

        <div class="alarm-types">
            <div class="type">
                <span class="icon mdi mdi-bell" style="color:${geoColors.critical.background}"></span>
                <div class="text">
                    <span style="color:${geoColors.critical.foreground}">${self.unMatchedAlarms.criticalCount}</span>
                </div>
            </div>
            <div class="type">
                <span class="icon mdi mdi-bell" style="color:${geoColors.major.background}"></span>
                <div class="text">
                    <span style="color:${geoColors.major.foreground}">${self.unMatchedAlarms.majorCount}</span>
                </div>
            </div>
            <div class="type">
                <span class="icon mdi mdi-bell" style="color:${geoColors.minor.background}"></span>
                <div class="text">
                    <span style="color:${geoColors.minor.foreground}">${self.unMatchedAlarms.minorCount}</span>
                </div>
            </div>
            <div class="type">
                <span class="icon mdi mdi-bell" style="color:${geoColors.observational.background}"></span>
                <div class="text">
                    <span style="color:${geoColors.observational.foreground}">${self.unMatchedAlarms.observationalCount}</span>
                </div>
            </div>
        </div>

        <div class="info-text">
            These alarm(s) sites are missing geo datafill or have not been created at all. This can be added in the Sites page.
        </div>
    `;
    if(self.unMatchedAlarms.list.length) {
        document.getElementById(`unmatched-alarms-list-control`).style.display = 'block';
    }
    else {
        document.getElementById(`unmatched-alarms-list-control`).style.display = 'none';
    }
};



export const saveNewView = (vueInstance, newView) => {
    let self = vueInstance;

    TELSA.loading(true);
    self.showViewsFavsDetails = false;
    // If they set this new view as the new default, then we have to unset the old one.
    if(newView.viewDefault) {
        for(let view of self.geoMapViews) {
            view.default = false;
        }    
    }
    // We don't want to save all the disregarded alarms
    let advancedFilters = JSON.parse(JSON.stringify(self.advancedFilters));
    advancedFilters.forEach(f => {
        f.status = [];
    });
    self.selectedGeoMapView = {
        user_id: self.$store.state.user.user_id,
        view_type: 'geomap',
        view_name: newView.viewName,
        view_device_type: self.$store.state.user.device_type,
        view_public: newView.viewPublic,
        view_grid_config: {
            generalSettings: self.generalSettings,
            map_coordinates: self.googleMapsObj.getCenter(),
            map_zoom: self.googleMapsObj.getZoom(),
            siteAlarmFilters: self.siteAlarmFilters,
            linkAlarmFilters: self.linkAlarmFilters,
            siteTagFilters: self.siteTagFilters,
            siteTechnicianFilters: self.siteTechnicianFilters,
            siteNetworkCategoryFilters: self.siteNetworkCategoryFilters,
            advancedFilters: advancedFilters
        },
        fav: true,
        default: newView.viewDefault,
    };
    self.geoMapViews.push(self.selectedGeoMapView);
    let route = `${TELSA.apiHost}views/add`;
    return self.$http.post(route, {args: {view: self.selectedGeoMapView}}).then(response => {
        let result = response.body;
        saveViewsFavs(self);
        buildMapViewsList(self);
    });
};


export const saveViewsFavs = (vueInstance) => {
    let self = vueInstance;

    let geoMapViewsFavs = [];
    for(let view of self.geoMapViews) {
        if(view.fav) {
            geoMapViewsFavs.push({
                user_id: view.user_id,
                view_name: view.view_name,
                default: view.default
            });
        }
    }
    let route = `${TELSA.apiHost}views/favs`;
    return self.$http.post(route, {args: {view_type: 'geomap', views_favs: geoMapViewsFavs}}).then(response => {
        let result = response.body;
        TELSA.loading(false);
    });
};

export const overwriteView = (vueInstance) => {
    let self = vueInstance;

    TELSA.loading(true);
    self.showViewsFavsDetails = false;
    // We don't want to save all the disregarded alarms
    let advancedFilters = JSON.parse(JSON.stringify(self.advancedFilters));
    advancedFilters.forEach(f => {
        f.status = [];
    });

    self.selectedGeoMapView.view_grid_config = {
        generalSettings: self.generalSettings,
        map_coordinates: self.googleMapsObj.getCenter(),
        map_zoom: self.googleMapsObj.getZoom(),
        siteAlarmFilters: self.siteAlarmFilters,
        linkAlarmFilters: self.linkAlarmFilters,
        siteTagFilters: self.siteTagFilters,
        siteTechnicianFilters: self.siteTechnicianFilters,
        siteNetworkCategoryFilters: self.siteNetworkCategoryFilters,
        advancedFilters: advancedFilters
    };
    let route = `${TELSA.apiHost}views/edit`;
    return self.$http.post(route, {args: {view: self.selectedGeoMapView, old_view_name: self.selectedGeoMapView.view_name}}).then(response => {
        let result = response.body;
        TELSA.loading(false);
    });
};

